import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import userHelper from '../../../Helpers/UserHelper';
import ProfileCard from './Global/ProfileCard';
import { capitalizeWords } from '../../../Helpers/UtilityMethods';

function AccountMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [profileUrl, setprofileUrl] = React.useState<string>('');

  const user = userHelper.getUser();
  const initials = userHelper.getUserInitials();

  const username = user?.name ?? user?.username ?? '';
  const email = user?.username ?? '';

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  React.useEffect(() => {
    loadInitData();
  }, []);

  const loadInitData = async () => {
    await loadProfile();
  };

  const loadProfile = async () => {
    try {
      const profileBlob = await userHelper.getUserProfile();
      setprofileUrl(URL.createObjectURL(profileBlob));
    } catch {
      setprofileUrl('');
    }
  };

  const logOut = () => {
    userHelper.logOut();
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title={`Account settings for ${capitalizeWords(username)}`}>
          <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
            <Avatar src={profileUrl} sx={{ width: 32, height: 32 }}>
              {initials}
            </Avatar>
          </IconButton>
        </Tooltip>
      </Box>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 8,
          sx: {
            overflow: 'hidden',
            borderRadius: 3,
            mt: 1.5,
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Box>
          <ProfileCard
            username={capitalizeWords(username)}
            email={email}
            profileimageurl={profileUrl}
            accounturl={`https://myaccount.microsoft.com/?login_hint=${email}`}
            logOut={logOut}
          />
        </Box>
      </Menu>
    </>
  );
}

export default AccountMenu;
